<template>
    <div class="floor__preview" v-bind:class="{'floor__preview--has-image': floor.image}">
        <div v-if="floor.image" class="image-item">
            <img :src="floor.image.path" class="image-item__image"/>

            <div class="image-item__controls">
                <custom-button type="button" @click="saveImage(null)" iconic><span icon remove></span>odebrat
                </custom-button>
                <custom-button type="button" @click="pickImage" iconic><span icon edit></span>změnit</custom-button>
            </div>
        </div>
        <div v-else>
            <button @click="pickImage" type="button" class="button button--select-image no-image">
                <img src="/assets/images/layout/no-image.svg" alt="">
                <div class="no-image__text">
                    <span class="no-image__icon">&plus;</span>
                    <span class="no-image__choose-image">Vybrat obrázek</span>
                </div>
            </button>
        </div>
    </div>
</template>

<script>
import {imagePickerModalParameters} from 'domovio-core/src/system/modal/modal.params';
import ImagePickerDialog from 'domovio-core/src/modules/MediaModule/components/Image/ImagePickerDialog';
import CustomButton from 'domovio-core/src/components/Button/CustomButton';

export default {
    name:       'FloorImage',
    components: {CustomButton},
    props:      {
        floor: {
            type:     Object,
            required: true,
        }
    },
    methods:    {
        pickImage() {
            this.$modal.show(ImagePickerDialog, {
                multipleSelect: false,
                onSelect:       ({imageIds}) => {
                    if (imageIds.length) {
                        this.saveImage(imageIds[0]);
                    }
                    this.$modal.hideAll();
                },
                onCancel:       () => this.$modal.hideAll(),
            }, imagePickerModalParameters());
        },
        saveImage(imageId) {
            const floor = {...this.floor};
            delete floor.rooms;
            delete floor.image;
            this.$store.dispatch('projects/project/floorPlan/updateFloor', {...floor, imageId})
                .catch((message) => this.$dmv.notifyError(message));
        }
    }
}
</script>
